import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import VariationDragDropItem from '../VariationDragDropItem';
import * as styles from './style';
import GenericListHeader from '../../GenericListHeader';
import withVariations from '../../../containers/GlobalVariations';
import {
  VARIATION_DRAG_DROP_COLUMNS,
  PRODUCT_CREATION_VARIATION_TYPE,
} from '../../../helpers/constants';

const ProductVariationColumn = ({
  items,
  onClickVariationActions,
  setTypeOfNewVariation,
  setIsDraggingOver,
}) => {
  const buttonClick = () => {
    onClickVariationActions();
    setTypeOfNewVariation(PRODUCT_CREATION_VARIATION_TYPE.product);
  };

  return (
    <styles.Container isBig>
      <GenericListHeader
        id={`${VARIATION_DRAG_DROP_COLUMNS.PRODUCT_VARIATIONS}-search`}
        title="Variações do Produto"
        desc="Abaixo as variações que já fazem parte do seu produto."
        button
        buttonId="new-product-variation-btn"
        buttonText="Criar Nova Variação"
        buttonOnClick={buttonClick}
        search={false}
      />

      <styles.DroppableContainer>
        <Droppable droppableId={VARIATION_DRAG_DROP_COLUMNS.PRODUCT_VARIATIONS}>
          {(provided, snapshot) => {
            setIsDraggingOver(snapshot.isDraggingOver);

            return (
              <styles.ItemList
                className="droppable"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {items.map((item, index) => (
                  <VariationDragDropItem
                    key={item.id}
                    item={item}
                    index={index}
                    showActions={true}
                  />
                ))}
                {items.length === 0 && (
                  <styles.StyledEmptyMessage big>
                    Ainda não há variações neste produto
                  </styles.StyledEmptyMessage>
                )}
                {provided.placeholder}
              </styles.ItemList>
            );
          }}
        </Droppable>
      </styles.DroppableContainer>
    </styles.Container>
  );
};

export default withVariations(ProductVariationColumn);



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/ProductVariationColumn/index.js